import { render, staticRenderFns } from "./header.vue?vue&type=template&id=1c3a4a0b"
import script from "./header.ts?vue&type=script&lang=js&external"
export * from "./header.ts?vue&type=script&lang=js&external"
import style0 from "./header.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports